(() => {
  if (window.__edSpotlightCompareInit) return;
  window.__edSpotlightCompareInit = true;

  const clamp = (value) => Math.max(0, Math.min(1, value));

  const initCompare = (root) => {
    if (!root || root.dataset.edCompareReady === 'true') return;
    const overlay = root.querySelector('.ed-spotlight__compare-overlay');
    const handle = root.querySelector('.ed-spotlight__compare-handle');
    if (!overlay || !handle) return;

    root.dataset.edCompareReady = 'true';
    let ratio = 0.5;
    let dragging = false;

    const apply = () => {
      overlay.style.width = `${ratio * 100}%`;
      handle.style.left = `${ratio * 100}%`;
      handle.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    };

    const setFromClientX = (clientX) => {
      const rect = root.getBoundingClientRect();
      if (!rect.width) return;
      ratio = clamp((clientX - rect.left) / rect.width);
      apply();
    };

    handle.addEventListener('pointerdown', (event) => {
      dragging = true;
      handle.setPointerCapture(event.pointerId);
      setFromClientX(event.clientX);
    });

    handle.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      setFromClientX(event.clientX);
    });

    const stop = () => {
      dragging = false;
    };

    handle.addEventListener('pointerup', stop);
    handle.addEventListener('pointercancel', stop);

    handle.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      ratio = clamp(ratio + (event.key === 'ArrowRight' ? 0.05 : -0.05));
      apply();
    });

    window.addEventListener('resize', apply);
    apply();
  };

  const initAll = () => {
    document.querySelectorAll('[data-ed-compare]').forEach(initCompare);
  };

  const boot = () => {
    initAll();
    const facet = document.querySelector('product-facet') || document.body;
    const observer = new MutationObserver(() => {
      initAll();
    });
    observer.observe(facet, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
